import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaTwitter, FaLinkedin, FaShare, FaTrophy, FaCheck } from 'react-icons/fa';

function ShareableBadge({ courseName, score, badgeColor = '#1B4965' }) {
  const [copied, setCopied] = useState(false);

  const shareText = `Je viens de terminer "${courseName}" avec un score de ${score}% sur DailyGlobe School ! #Formation #Journalisme`;
  
  const shareOnTwitter = () => {
    const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}`;
    window.open(url, '_blank', 'width=600,height=400');
  };

  const shareOnLinkedIn = () => {
    const url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(window.location.origin)}&summary=${encodeURIComponent(shareText)}`;
    window.open(url, '_blank', 'width=600,height=400');
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(shareText);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <motion.div
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      className="relative"
    >
      {/* Badge visuel */}
      <div 
        className="w-48 h-48 mx-auto rounded-full border-8 flex flex-col items-center justify-center text-white relative overflow-hidden"
        style={{ 
          borderColor: badgeColor,
          background: `linear-gradient(135deg, ${badgeColor} 0%, ${badgeColor}cc 100%)`
        }}
      >
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-2 left-1/2 transform -translate-x-1/2">
            <FaTrophy className="text-6xl" />
          </div>
        </div>
        <div className="relative z-10 text-center px-4">
          <FaTrophy className="text-3xl mx-auto mb-2" />
          <div className="text-4xl font-bold">{score}%</div>
          <div className="text-xs mt-1 opacity-90">CERTIFICAT</div>
        </div>
      </div>

      {/* Texte du cours */}
      <div className="text-center mt-4 mb-4">
        <p className="font-bold text-lg" style={{ color: badgeColor }}>{courseName}</p>
        <p className="text-sm text-gray-600">Cours terminé avec succès !</p>
      </div>

      {/* Boutons de partage */}
      <div className="flex justify-center space-x-3">
        <button
          onClick={shareOnTwitter}
          className="p-3 rounded-full bg-[#1DA1F2] text-white hover:bg-[#1a8cd8] transition-colors"
          title="Partager sur Twitter"
          data-testid="share-twitter"
        >
          <FaTwitter className="text-xl" />
        </button>
        <button
          onClick={shareOnLinkedIn}
          className="p-3 rounded-full bg-[#0A66C2] text-white hover:bg-[#094d92] transition-colors"
          title="Partager sur LinkedIn"
          data-testid="share-linkedin"
        >
          <FaLinkedin className="text-xl" />
        </button>
        <button
          onClick={copyToClipboard}
          className={`p-3 rounded-full transition-colors ${
            copied 
              ? 'bg-green-500 text-white' 
              : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
          }`}
          title="Copier le texte"
          data-testid="share-copy"
        >
          {copied ? <FaCheck className="text-xl" /> : <FaShare className="text-xl" />}
        </button>
      </div>
    </motion.div>
  );
}

export default ShareableBadge;
